import {initPromoStaticpromo} from "./init";
import {otto} from "@otto-ec/global-resources/nexus";

otto.ft3.promo.staticpromo.assignNamespace({
    init: () => {
        initPromoStaticpromo();
    }
});